<template>
  <div v-if="isShowLoading">
    <DDLoading />
  </div>
  <div class="img-group" v-else-if="isHasInfo && paths && paths.length > 0">
    <div v-for="v in paths" :key="v" class="img-box">
      <img :src="v" alt="食品安全" />
    </div>
  </div>
  <div v-else>
    <DDLost :errorType="'error'" errorDesc="无法查询到食品安全检测报告" />
  </div>
</template>

<script>
import http from "@/utils/request.js";
import DDLoading from "@/components/Loading.vue";
import DDLost from "@/views/Lost.vue";
import ModuleServiceUrl from "@/utils/moduleServiceUrl";

export default {
  data() {
    return {
      paths: [],
      isShowLoading: true, // 显示loading
      isHasInfo: true // 判断是否有查到数据,如果没有的话显示 溯源信息迷路了…
    };
  },
  components: { DDLoading, DDLost },
  async created() {
    await ModuleServiceUrl.judgeCtsServiceUrl();
    // 解析url   http://trace.te.test.srv.mc.dd/#/farmquality?product_id=17&station_id=1
    // const tempUrl = `http://localhost:8080/#/farmquality?product_id=17&station_id=1`;
    const tempUrl = location.href;
    const { productId, stationId } = this.parseUrlHash(tempUrl);
    const url = `${ModuleServiceUrl.getCtsUrl()}/api/v1/pesticide/report`;
    const params = { productId, stationId };
    const result = await http.get(`${url}`, { params });
    let { data } = result;
    const { success } = result;
    if (success) {
      data = data || [];
      this.isShowLoading = false;
      const { paths, skuId } = data;
      if (!skuId) {
        this.isHasInfo = false;
        return;
      }
      this.paths = paths || []; // 兼容paths为null的场景
    }
  },
  methods: {
    parseUrlHash(url) {
      const _temp = url.substr(url.indexOf("?") + 1);
      const arrParam = _temp.split("&");
      let _productId;
      let _stationId;
      arrParam.forEach(v => {
        const _tempV = v;
        const _tempArr = _tempV.split("=");
        if (_tempArr[0] == "product_id") {
          _productId = _tempArr[1];
        }
        if (_tempArr[0] == "station_id") {
          _stationId = _tempArr[1];
        }
      });
      return {
        productId: _productId,
        stationId: _stationId
      };
    }
  }
};
</script>

<style lang="less">
.img-group {
  overflow: hidden;
  .img-box {
    float: left;
    user-select: none;
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>
